import React from 'react'
import PropTypes from 'prop-types'
import withRouter from '../../lib/withRouter'
import Component from '../common/Component'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/SBCConfigurations'
import connectIndex from '../../lib/connectIndex'

export class ConfigurationsIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    records: PropTypes.array,
    pagination: PropTypes.object,
    flashMessages: PropTypes.array.isRequired,
    filterActions: PropTypes.object,
    filters: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static searchColumns = ['source_identifier']

  static defaultProps = {
    searchColumns: this.searchColumns
  }

  static sbcConfigColumns = [
    {
      key: 'source_identifier',
      label: 'Source ID',
      filterable: false,
      sortable: false
    },
    {
      key: 'lgc_customer',
      label: 'LGC Customer',
      filterable: true,
      sortable: false,
      display: IndexComponent.booleanDisplay
    },
    {
      key: 'created_at',
      label: 'Created At',
      display: IndexComponent.dateTimeDisplay,
      filterable: false,
      sortable: true
    }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/configurations/sbc"
          resetPath="/configurations"
          name="SBC Configuration"
          pagination={this.props.pagination}
          columns={ConfigurationsIndex.sbcConfigColumns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          filterActions={this.props.filterActions}
          searchPlaceholder="Search by Source Id"
          searchColumns={this.props.searchColumns}
          newRecordLinkTitle="New SBC Configuration"
          history={this.props.history}
          filterable
        />
      </div>
    )
  }
}
const filters = [
  {
    key: 'lgc_customer',
    options: [
      { value: 'true', text: 'Yes' },
      { value: 'false', text: 'No' }
    ]
  }
]

export default connectIndex(withRouter(ConfigurationsIndex), 'sbcConfigurations', actions, filters)
